

































import Vue from 'vue'

export default Vue.extend({
  name: 'XModal',
  inheritAttrs: false,
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    modalClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClickOutside(): void {
      this.$emit('click:outside')
    },
  },
})
